import { useQuery } from "@tanstack/react-query"
import { auth } from  '@shared/api/services'

export const useMaintenance = () => {
	const response = useQuery({
		queryKey: ['maintenance'], 
		queryFn: () => auth.getMaintenance(), 
		select: (data) => data.data,
		retry: 3
	})

	return response
}